import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { formatImageCloudinary } from '~/helpers/image-helper';
export default {
  name: 'CommercialBanner',
  props: {
    image: {
      type: String,
      required: true
    },
    link: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      opened: false
    };
  },
  computed: {
    currentImage: function currentImage() {
      return formatImageCloudinary(this.image);
    }
  },
  methods: {
    animate: function animate() {
      var _this = this;

      this.$nextTick(function () {
        _this.opened = true;
      });
    }
  }
};